export default "__VITE_ASSET__y6kRpjfU__"